import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

export type LicenceCardStyle = 'default' | 'warning';

@Component({
  selector: 'app-licence-card',
  templateUrl: './licence-card.component.html',
  styleUrl: './licence-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.licence-card--warning]': "cardStyle() === 'warning'",
    '[class.licence-card--over]': 'isOverLimit()',
  },
})
export class LicenceCardComponent {
  label = input.required<string>();

  // Plain text display (e.g. licence type name). Rendered when currentValue is null;
  // otherwise the structured currentValue/maxValue view below takes precedence.
  value = input<string | null>(null);

  // Structured "current / max" numeric display (used by both org and modal cards).
  // Set currentValue (and maxValue) to render this instead of the plain value.
  currentValue = input<number | null>(null);
  maxValue = input<number | null>(null);

  cardStyle = input<LicenceCardStyle>('default');
  showBar = input(false);
  barPercent = input(0);
  isOverLimit = input(false);

  protected readonly formattedMax = computed(() => {
    const max = this.maxValue();
    if (max === null || max === Infinity) return '∞';
    return String(max);
  });
}
